module.exports = __webpack_public_path__ + "f7ad943d4ac3b7e429f0984207daf9cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/list/subImg/drgl-banner.jpg
// module id = 449
// module chunks = 0